// DiagiaShell — layout wrapper for every /diagia/* route.
//
// Lays out the persistent sidebar + topbar + outlet. Loads the identity
// once on mount so the sidebar can decide which menu groups to render.

import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import DiagiaSidebar from './DiagiaSidebar';
import DiagiaTopbar from './DiagiaTopbar';
import useDiagiaApi from './hooks/useDiagiaApi';
import './diagia.css';

export default function DiagiaShell() {
  const api = useDiagiaApi();
  const [identity, setIdentity] = useState(null);
  const [invitations, setInvitations] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.whoami()
      .then((data) => { if (!cancelled) setIdentity(data); })
      .catch(() => {
        if (!cancelled) setIdentity({ authenticated: false });
      });
    return () => { cancelled = true; };
  }, [api]);

  const refreshInvitations = React.useCallback(async () => {
    try {
      const data = await api.listMyInvitations();
      setInvitations(data);
    } catch {
      setInvitations({ items: [], counts: {} });
    }
  }, [api]);

  useEffect(() => {
    if (identity?.authenticated) refreshInvitations();
  }, [identity?.authenticated, refreshInvitations]);

  const pendingCount = invitations?.counts?.pending || 0;

  return (
    <div className="dia-shell">
      <DiagiaSidebar identity={identity} pendingInvitations={pendingCount} />
      <div className="dia-main">
        <DiagiaTopbar />
        <div className="dia-content">
          <Outlet context={{ identity, invitations, refreshInvitations }} />
        </div>
      </div>
    </div>
  );
}
